import { apiGetPackages } from 'api/packages';
import packagesTypes from '../types/packages';

export const getPackages = cb => ({
  isAsyncCall: true,
  baseType: packagesTypes.GET_PACKAGES,
  payload: {},
  asyncCall: () => apiGetPackages(),
  afterSuccessCall: (_dispatch, response) => {
    if (cb) cb(response);
  },
  afterFailureCall: (_dispatch, err) => {
    if (cb) cb(null, err);
  },
});
